import { handleActions } from 'redux-actions';
import { RootState } from '~/types';

const SET = 'approvalRequired/set';
const CLEAR = 'approvalRequired/clear';

export type State = {
  approvalCaseId: string | null;
};

export const approvalRequired = (id: string) => ({
  type: SET,
  payload: { id },
});

export const clearApprovalRequired = () => ({
  type: CLEAR,
});

const initialState: State = {
  approvalCaseId: null,
};

export default handleActions<State, any>(
  {
    [SET]: (state, { payload }) => ({ ...state, approvalCaseId: payload.id }),
    [CLEAR]: (state) => ({ ...state, approvalCaseId: null }),
  },
  initialState
);

export const selectors = {
  getApprovalCaseId: (state: RootState) => state.approvalRequired.approvalCaseId,
};
